import React from 'react';

import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';

import ServiceItem from './components/ServiceItem';
import Divider from '@material-ui/core/Divider';

import styles from './styles';
const useStyles = makeStyles(styles);

function TemporalServices({ items, onSelect, label }) {
    const classes = useStyles();
    const renderServiceList = (list) => (
        <ul className={classes.serviceList}>
            {list.map((service, index) => [
                <ServiceItem key={`${service.cdServico}-${index}`} service={service} onSelect={onSelect} />,
                <Divider key={`div-${service.cdServico}-${index}`} />,
            ])}
        </ul>
    );

    return (
        <div className={classes.container}>
            {items.length && (
                <>
                    <div className={classes.label}>
                        <FormattedMessage id={label} />
                    </div>
                    {renderServiceList(items)}
                </>
            )}
        </div>
    );
}

export default TemporalServices;
